<div class="workflow-main-shell">
  <div class="app-nav index-sticky-header">
    <ul>
      <li><a [class.active]="activeTab === 'Entity List'" (click)="setTab('Entity List')">Entity List</a></li>
      <li class="separator"><i class="fa fa-ellipsis-v"></i></li>
    </ul>
  </div>

  <div class="app-body">
    <div class="actions">
      <button type="button" class="save-button" (click)="refresh()">Refresh</button>
      <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    </div>
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    @if (!showFormLoader) {
<div>
      @if (rowDataKeys.length > 0) {
<table class="table table-bordered form-inline custom-table">
        <tbody>
          @for (key of rowDataKeys; track $index) {
<tr>
            <td><strong>{{ key }}</strong></td>
            <td>{{ rowData[key] }}</td>
          </tr>
}
        </tbody>
      </table>
}
      @if (rowDataKeys.length === 0) {
<div class="no-data">No workflow records available for the current filter set.</div>
}
    </div>
}
  </div>
</div>
